import styled from 'styled-components'

export const B = styled.span`
  font-weight: 600;
`
